import { MenuItem } from "prosemirror-menu";
import type { Command } from "prosemirror-state";

import { t } from "i18n/i18n";
import { toolbarIndentDecreaseIcon, toolbarIndentIncreaseIcon } from "mds/utils/toolbar-icons";

const MAX_INDENT = 8;

/**
 * Increase indentation of all selected blocks by one level (up to MAX_INDENT).
 */
export const addIndent: Command = (state, dispatch) => {
  const blocks = state.selection.$from.blockRange(state.selection.$to);
  if (!blocks) return false;
  const tr = state.tr;
  for (let i = blocks.startIndex, pos = blocks.start; i < blocks.endIndex; i += 1) {
    const block = blocks.parent.child(i);
    if (block.attrs.indent < MAX_INDENT)
      tr.setNodeAttribute(pos, "indent", (block.attrs.indent || 0) + 1);
    pos += block.nodeSize;
  }
  if (!tr.steps.length) return false;
  if (dispatch) dispatch(tr);
  return true;
};

/**
 * Decrease indentation of all selected blocks by one level (down to 0).
 */
export const removeIndent: Command = (state, dispatch) => {
  const blocks = state.selection.$from.blockRange(state.selection.$to);
  if (!blocks) return false;
  const tr = state.tr;
  for (let i = blocks.startIndex, pos = blocks.start; i < blocks.endIndex; i += 1) {
    const block = blocks.parent.child(i);
    if (block.attrs.indent) tr.setNodeAttribute(pos, "indent", block.attrs.indent - 1);
    pos += block.nodeSize;
  }
  if (!tr.steps.length) return false;
  if (dispatch) dispatch(tr);
  return true;
};

export const indentIncreaseItem = new MenuItem({
  title: t("worksheet.rich_text_editor.indent_increase"),
  icon: toolbarIndentIncreaseIcon,
  // enable() uses the command itself as a dry-run check (ProseMirror convention):
  // calling a command with no dispatch returns true/false without making changes.
  enable: (state) => addIndent(state),
  run: (state, dispatch) => addIndent(state, dispatch),
});

export const indentDecreaseItem = new MenuItem({
  title: t("worksheet.rich_text_editor.indent_decrease"),
  icon: toolbarIndentDecreaseIcon,
  enable: (state) => removeIndent(state),
  run: (state, dispatch) => removeIndent(state, dispatch),
});
